import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useLocation, useNavigate } from "react-router-dom";
import TokenService from "../utility";
import { pages } from "./menus";
import { useTheme } from "@mui/material";

const MenuBar: React.FunctionComponent = () => {
  const location = useLocation();
  let navigate = useNavigate();
  let role = TokenService.getTokenUserRole();
  const theme = useTheme();
  let themeMode = localStorage.getItem("themeMode");
  let currentPath: any = location?.pathname.split("/")?.[1];
  const [dynamicanchorElNav, setDynamicAnchorElNav] =
    React.useState<null | HTMLElement>(null);
  const handleOpenDynamicMenu = (event: React.MouseEvent<HTMLElement>) => {
    setDynamicAnchorElNav(event.currentTarget);
  };
  const handleCloseDynamicMenu = () => {
    setDynamicAnchorElNav(null);
  };
  useEffect(() => {
    if (themeMode === "dark") {
      theme.palette.mode = "dark";
    } else {
      theme.palette.mode = "light";
    }
  }, [themeMode, theme]);

  return (
    <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
      {pages.map((page, index) =>
        !page.role.includes(role) ? (
          <div key={index}></div>
        ) : page.subpages ? (
          <Box key="submenu">
            <Button
              key={page.title + index + 3}
              onClick={handleOpenDynamicMenu}
              sx={{
                my: 2,
                color:
                  page.route === currentPath ? "primary.main" : "text.primary",
                display: "block",
              }}
            >
              {page.title}
            </Button>

            <Menu
              key={index}
              sx={{ mt: "45px" }}
              id="menu-middle-appbar"
              anchorEl={dynamicanchorElNav}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(dynamicanchorElNav)}
              onClose={handleCloseDynamicMenu}
            >
              {page.subpages.map((subpage) => (
                <MenuItem
                  key={subpage.title}
                  onClick={() => {
                    setDynamicAnchorElNav(null);
                    navigate(subpage.route);
                  }}
                >
                  <Typography textAlign="center">{subpage.title}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        ) : (
          <Button
            key={page.title + index + 3}
            onClick={() => navigate(page.route)}
            sx={{
              my: 2,
              color:
                page.route === currentPath ? "primary.main" : "text.primary",
              display: "block",
            }}
          >
            {page.title}
          </Button>
        )
      )}
    </Box>
  );
};

export default MenuBar;
